import { signalStore, withComputed, withProps, withState } from "@ngrx/signals";
import { inject } from "@angular/core";
import { AvailWeekly } from "../modules/s25-avail-weekly/s25.avail.weekly.util";
import { LoginStore } from "./login.store";
import { s25Resource } from "../util/s25.resource";
import { UserprefService } from "../services/userpref.service";

type State = {};

export const UserStore = signalStore(
    { providedIn: "root" },
    withState<State>({} satisfies State),
    withProps(() => ({
        _loginStore: inject(LoginStore),
    })),
    withComputed((store) => ({
        loggedIn: () => store._loginStore.loggedIn(),
        id: () => store._loginStore.user()?.userId,
        username: () => store._loginStore.user()?.userName,
        contactName: () => store._loginStore.user()?.contactName,
        secGroupId: () => store._loginStore.user()?.securityGroupId,
        secGroupName: () => store._loginStore.user()?.securityGroupName,
    })),
    withProps((store) => ({
        _timezone: s25Resource({
            params: () => store.id() ?? false,
            loader: ({ params, abortSignal }) => UserprefService.getTZName(),
        }),
        _24Hours: s25Resource({
            params: () => store.id() ?? false,
            loader: ({ params, abortSignal }) => UserprefService.getIs24HourTime(),
        }),
        _dateTimeFormat: s25Resource({
            params: () => store.id() ?? false,
            loader: ({ params, abortSignal }) => UserprefService.getS25DateTimeformat(),
        }),
        _dateFormat: s25Resource({
            params: () => store.id() ?? false,
            loader: ({ params, abortSignal }) => UserprefService.getS25Dateformat(),
        }),
        _timeFormat: s25Resource({
            params: () => store.id() ?? false,
            loader: ({ params, abortSignal }) => UserprefService.getS25Timeformat(),
        }),
        _weekstart: s25Resource({
            params: () => store.id() ?? false,
            loader: () => UserprefService.getWeekstart(),
        }),
    })),
    withComputed((store) => ({
        timezone: () => store._timezone.value() ?? "America/Los_Angeles",
        is24Hours: () => store._24Hours.value() ?? false,
        dateTimeFormat: () => store._dateTimeFormat.value(),
        dateFormat: () => store._dateFormat.value(),
        timeFormat: () => store._timeFormat.value(),
        weekstart: () => store._weekstart.value() ?? AvailWeekly.dows.Sunday,
        isService25: () => store.username() === "service25",
    })),
);

export type UserStore = InstanceType<typeof UserStore>;
